import { findClosestMagnitude } from '@utils/temporal'
import { stageWidthSelector } from './stage_selectors'
import { surfaceDimensionsSelector, paddedDurationSelector } from './scroller_selectors'
import { calculateTicks } from '../utils/scale'
import { createHorizontalTimelineSelector as createSelector } from '../selectors'
import { TickDefinition } from '../types/types'
import { HorizontalTimelineState } from '../reducers'

const TICKS_PER_PIXEL = 0.004

// total number of ticks on whole timeline
const numTicksSelector: (state: HorizontalTimelineState, props: any) => number = createSelector(
  stageWidthSelector,
  function (stageWidth) {
    return stageWidth * TICKS_PER_PIXEL
  }
)

export const axisTicksSelector: (state: HorizontalTimelineState, props: any) => TickDefinition[] = createSelector(
  stageWidthSelector,
  surfaceDimensionsSelector,
  paddedDurationSelector,
  numTicksSelector,
  function (stageWidth, surfaceDimensions, durationData, numTicks) {
    //console.log("Expensive axisTicksSelector selector", stageWidth, surfaceDimensions, durationData)
    const surfaceWidth = surfaceDimensions.width
    const duration = durationData.duration
    const onScreenDuration = (stageWidth / surfaceWidth) * duration
    const segmentDuration = onScreenDuration / (numTicks + 1) // get the ideal duration of a segment
    const preferredMagnitude = findClosestMagnitude(segmentDuration) // find the best duration of a segment. i.e. a year
    const ticks: TickDefinition[] = calculateTicks(
      preferredMagnitude,
      durationData.startTime,
      durationData.endTime,
      duration,
      surfaceDimensions.width
    )
    return ticks
  }
)
